import React, { Fragment } from 'react'
import HelpdeskComponent from '../../components/HelpDesk/helpdesk.components'

const HelpdeskPage = (props) => {
  return (
    <>
      <HelpdeskComponent />
    </>
  )
}

export default HelpdeskPage
